import React, { useEffect, useState } from 'react';
import { IoMdPlayCircle } from "react-icons/io";
import { FaPauseCircle } from "react-icons/fa";
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';

const Videolist = ({ vidlst }) => {
  const { vicon, setVicon, setVcode } = useAccessCard();
  const [activeVideo, setActiveVideo] = useState(vicon);

  useEffect(() => {
    setActiveVideo(vicon);
  }, [vicon]);

  const handleSetVideoLink = (video) => {
    setVcode(video);
    setVicon(video?.video_link);
    setActiveVideo(video?.video_link);
  };

  return (
    <div className='video_container'>
      {vidlst.map((item, index) => (
        <div className='video_list_container' key={item.video_link} onClick={() => handleSetVideoLink(item)}>
          <div className='video_list_card'>
            <div>
              {activeVideo === item.video_link ? (
                <FaPauseCircle className="course_icon video" size={33} />
              ) : (
                <IoMdPlayCircle className="course_icon video" size={35} />
              )}
            </div>
            <div>
              <span>{item.video_title}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Videolist;
